import { fetchApi } from '@/config/axiosSetting';
import {
  DriverInfoType,
  DriverInfoTypeParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDriverInfo/driverInfoQuery.type';

export const driverInfoQueryFunction = (
  params: DriverInfoTypeParams,
): Promise<DriverInfoType> => {
  return fetchApi.get(
    `/property/reports/${params?.id}/accident_users/damaged/user_information/driver/`,
    {
      params,
    },
  );
};
